import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import ReadAxios from '../axiosComponent/read';
const MyServiceType = ({
    field: { name },
    form: { setFieldValue },
    ...props
}) => {
    const [content, setcontent] = useState([])
    const [loading, setloading] = useState(false)
    useEffect(() => {
        setloading(true)
        ReadAxios({ completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/masters/service/type`, readItems: { searchTerm: ' ' } })
            .then((result) => {
                console.log('>>>>', result.data.data)
                setcontent(result.data.data)
                setloading(false)
            })
    }, [])
    let options = []
    if (content.length > 0) {
        content.map((object, index) => {
            let temp = {}
            temp.key = object.service_type_id
            temp.text = object.service_type_name
            temp.value = object.service_type_id
            return options[index] = temp
        })
    }
    let handleChange = (value, data) => {
        setFieldValue(name, data.value)
        if(props.onChangeExtra) props.onChangeExtra(data.value)
    }
    return (
        <Dropdown
            selection
            search
            clearable
            loading={loading ? true : false}
            placeholder={props.placeholder}
            style={{ width: '100%' }}
            onChange={handleChange}
            options={options}
            error={props.error}
            noResultsMessage="Search for Result"
            {...props}
        />

    )
}

export default MyServiceType